import { defineStyleConfig } from '@chakra-ui/system';

const baseStyle = {
    borderColor: 'slt-black.200',
    marginTop: 8,
    marginBottom: 8,
};

export const Divider = defineStyleConfig({
    baseStyle,
});
